import * as Yup from "yup";
import { forceInt } from "Utils";

export const ImageMetadataValidationSchema = Yup.object().shape({});

export const ImageMetadataObjectSchema = {
    id: null,
    label: null,
    value: null,
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let im = Object.assign({}, ImageMetadataObjectSchema, {
        id: forceInt(requestData.id),
        label: requestData.label,
        value: requestData.value,
    });

    return im;
}
